// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__4o5bd","detailsBorder":"styles_detailsBorder__3Gvis"};